import { useTranslation } from "next-i18next";

import { Typography } from "@mui/material";
import { Box } from "@mui/system";

import { BracketLogo, TextLogo } from "./Footer.styled";

export const FooterHeader = () => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "8px",
          alignItems: "start",
        }}
      >
        <TextLogo />

        <Typography variant="body" component="p" sx={{ maxWidth: "580px" }}>
          {t("solving challenges with latest technology")}
        </Typography>
      </Box>

      <BracketLogo />
    </Box>
  );
};
